/* eslint-disable class-methods-use-this */
import * as api from '../../../../utils/apiClient';

class UsersManage {
  async changeStatus(userId, body) {
    const response = await api.post(
      `/kernel/account-manage/${userId}/change-status`,
      {},
      body
    );
    const responseJson = await response.json();
    return responseJson;
  }
}

export default new UsersManage();



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/users/services/UsersManage/index.js